import React from 'react';
import GeoBrandLogo from './GeoBrandLogo';

/** SVG foreignObject wrapper for chart plot markers. */
export default function GeoBrandLogoChartMarker({
  x,
  y,
  size,
  name,
  color,
  logoUrl,
  isClient = false,
}) {
  const half = size / 2;

  return (
    <foreignObject
      x={x - half}
      y={y - half}
      width={size}
      height={size}
      className="geo-insights-visibility-chart__brand-logo-fo"
    >
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        className="geo-insights-visibility-chart__brand-logo-host"
      >
        <GeoBrandLogo
          name={name}
          color={color}
          logoUrl={logoUrl}
          size={size}
          isClient={isClient}
          className="geo-brand-logo-img--chart"
        />
      </div>
    </foreignObject>
  );
}
